<template>
  <main class="bh-page article-hero">
    <span class="tag">404</span>
    <h1>Page <em>Not Found</em></h1>
    <p class="meta">The page you requested does not exist.</p>
    <p style="margin-top:2rem"><a href="/" class="nav-cta">Back Home</a></p>
  </main>
</template>

<style scoped>
.bh-page{font-family:'Inter',sans-serif;background:#080808;color:#e8e4df;min-height:100vh;text-align:center;padding:8rem 2rem;}
:root,.bh-page{--gold:#d4a574;--gold-light:#f0d4a8}.tag{font-size:.7rem;color:var(--gold);letter-spacing:.2em;text-transform:uppercase}.nav-cta{padding:.7rem 1.8rem;border:1px solid rgba(212,165,116,.5);color:var(--gold);font-size:.7rem;letter-spacing:.2em;text-transform:uppercase;text-decoration:none}
h1{font-family:'Noto Serif JP',serif;font-size:2.8rem}em{font-style:normal;color:var(--gold)}.meta{color:rgba(255,255,255,.35)}
</style>
